import React from "react";

export default function ActionPointTooltip({ text, show = false }) {
  return (
    <div className={`view__links__tooltip ${show && text ? "show" : ""}`}>
      {text}
    </div>
  );
}
